import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = true;

const slice = createSlice({
  name: '$enableNonMemberPhoneNumberRequired',
  initialState,
  reducers: {
    setEnableNonMemberPhoneNumberRequired(
      state,
      action: PayloadAction<boolean>,
    ) {
      return Boolean(action.payload);
    },
  },
});

export const { setEnableNonMemberPhoneNumberRequired } = slice.actions;
export default slice.reducer;
